import BridgeV2 from "@akulaku/web-bridge";

import { isIos } from "./index";

// 通用调整方法
const linkTo = (link) => {
  link = link.trim();
  if (window.__adjustTracker) {
    link = window.__adjustTracker(link);
  }
  // web跳转
  // 宿主app
  if (BridgeV2.isAkulaku()) {
    BridgeV2.jump({ url: link });
  } else {
    //宿主浏览器
    //新开tab
    // Ios异步调用window.open无效
    if (isIos()) {
      window.location.href = link;
    } else {
      window.open(link);
    }
  }
};

export default linkTo;
